import Spinner from '../../Spinner'
import styles from './SeekingOverlay.module.css'

export default function SeekingOverlay () {
  return (
    <div className={styles.overlay} data-replay-ui>
      <Spinner size={20} />
    </div>
  )
}
